"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapseHead = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _SvgInSelectArrow = require("../svg/interface/SvgInSelectArrow");

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c17692a46{display:block}.ccb6dae48{font-size:1rem;font-weight:500;line-height:1.125rem;color:var(--color-flomni-blue-70);display:grid;grid-template-columns:1fr fit-content(100%)}.c6bb26e0c{width:.5625rem;color:var(--color-flomni-blue-70);display:flex;align-items:center}.c6bb26e0c:hover{opacity:.7}.cc933f30f{margin-top:.6875rem;font-size:.75rem;font-weight:400;line-height:.8125rem;color:var(--color-flomni-gray-70)}.cf8a4d098{cursor:pointer}.ca8851a12 .c6bb26e0c{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.ccb95de8e .c6bb26e0c{-webkit-transform:rotate(0);transform:rotate(0)}");
var styles = {
  root: 'c17692a46',
  title: 'ccb6dae48',
  arrow: 'c6bb26e0c',
  description: 'cc933f30f',
  '--openable': 'cf8a4d098',
  '--open': 'ca8851a12',
  '--close': 'ccb95de8e'
};

var CollapseHead = function CollapseHead(props) {
  var openable = props.openable,
      onClick = props.onClick,
      open = props.open,
      title = props.title,
      description = props.description,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function (event) {
    if (!openable) return;
    onClick(event);
  }, [onClick, openable]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.openable, openable), (0, _defineProperty2.default)({}, cn.open, openable && open), (0, _defineProperty2.default)({}, cn.close, openable && !open)),
    onClick: onClickHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, /*#__PURE__*/_react.default.createElement("span", null, title), !openable ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.arrow
  }, /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null))), !description ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.description
  }, description));
};

exports.CollapseHead = CollapseHead;
CollapseHead.propTypes = {
  /* component logic props */
  openable: _propTypes.bool,
  open: _propTypes.bool,
  onClick: _propTypes.func,
  title: _propTypes.node.isRequired,
  description: _propTypes.node,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
CollapseHead.defaultProps = {
  openable: false,
  open: false,
  onClick: function onClick() {},
  classes: {},
  description: null
};